<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <span class="fa-stack fa-1x color-gray-2 font-18 mr-3">
              <em class="fas fa-circle fa-stack-2x" />
              <em class="fas fa-comment fa-stack-1x fa-inverse" />
            </span>
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.date | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.date | hour }}
              </div>
            </div>
          </template>
          <div class="row pb-4">
            <div class="col-12 ml-5 pt-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Comentario:
              </div>
              <div class="color-black font-16 font-weight-normal pt-2">
                {{ item.comment }}
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from 'timeline';
import CustomResultNotFound from 'custom-result-not-found';
import { getFindingComments as _getFindingComments } from '@/modules/shared/scholarship.api.js';

export default {
  name: 'FindingCommentList',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
  },
  filters: {
    bold(value) {
      if (!value) return '';
      return value.replace(/(\\b)/g, '<strong>');
    },
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    selectedFilter: null,
    filterOptions: [],
    items: [],
  }),
  async mounted() {
    await this.callGetEventLogs();
  },
  methods: {
    async callGetEventLogs() {
      const { data } = await _getFindingComments(this.value);
      this.items = data;
    },
  },
};
</script>

<style scoped lang="scss">
.gradient-border {
  box-shadow: 8px 0 3px -3px #efefef !important;
}

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: #fff !important;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #fafafa;
  }
}
</style>
